export default __webpack_public_path__ + "static/media/gc_logo.6df0a90d.png";